var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "consoleIndex-wrap" },
    [
      _c("img", {
        staticClass: "tbg",
        staticStyle: { "margin-top": "-60px" },
        attrs: { src: "/images/console/tbg.png" }
      }),
      _c("div", { staticClass: "main-box" }, [
        _c("div", { staticClass: "left-box" }, [
          _c("div", { staticClass: "box b1" }, [
            _c("div", { staticClass: "top" }, [
              _c("img", { attrs: { src: "/images/console/start-i.png" } }),
              _c("span", { staticClass: "title" }, [
                _vm._v(" 简单 3 步，快速开启企业电子签署之旅 ~ ")
              ]),
              _c(
                "span",
                { staticClass: "todo can_use", on: { click: _vm.turnToJC } },
                [_vm._v("查看教程 >>")]
              )
            ]),
            _c("div", { staticClass: "img_content" }, [
              _c("img", {
                staticClass: "can_use tp",
                attrs: { src: "/images/console/mem-a.png" },
                on: { click: _vm.turnToZZ }
              }),
              _c("img", {
                staticClass: "po1",
                attrs: { src: "/images/console/arr-r-a.png" }
              }),
              _c("img", {
                staticClass: "can_use tp",
                attrs: { src: "/images/console/sp-a.png" },
                on: { click: _vm.turnToSP }
              }),
              _c("img", {
                staticClass: "po2",
                attrs: { src: "/images/console/arr-r-a.png" }
              }),
              _c("img", {
                staticClass: "can_use tp",
                attrs: { src: "/images/console/yz-a.png" },
                on: { click: _vm.turnToYZ }
              })
            ])
          ]),
          _c("div", { staticClass: "box b2" }, [
            _c("div", { staticClass: "top" }, [
              _c("img", { attrs: { src: "/images/console/zz-i.png" } }),
              _c("span", { staticClass: "title" }, [_vm._v(" 企业组织管理")]),
              _c(
                "span",
                { staticClass: "can_use todo", on: { click: _vm.turnToZZ } },
                [_vm._v("立刻进入>>")]
              )
            ]),
            _vm._m(0)
          ]),
          _c("div", { staticClass: "box b3" }, [
            _c("div", { staticClass: "top" }, [
              _c("img", { attrs: { src: "/images/console/sp-i.png" } }),
              _c("span", { staticClass: "title" }, [_vm._v(" 成员合同审批")]),
              _c(
                "span",
                { staticClass: "can_use todo", on: { click: _vm.turnToSP } },
                [_vm._v("立刻进入>>")]
              )
            ]),
            _vm._m(1)
          ]),
          _c("div", { staticClass: "box b2" }, [
            _c("div", { staticClass: "top" }, [
              _c("img", { attrs: { src: "/images/console/yz-i.png" } }),
              _c("span", { staticClass: "title" }, [_vm._v(" 印章授权")]),
              _c(
                "span",
                { staticClass: "can_use todo", on: { click: _vm.turnToYZ } },
                [_vm._v("立刻进入>>")]
              )
            ]),
            _vm._m(2)
          ]),
          _c("div", { staticClass: "box b2" }, [
            _c("div", { staticClass: "top" }, [
              _c("img", { attrs: { src: "/images/console/mb-i.png" } }),
              _c("span", { staticClass: "title" }, [_vm._v(" 模板授权")]),
              _c(
                "span",
                { staticClass: "can_use todo", on: { click: _vm.turnToMB } },
                [_vm._v("立刻进入>>")]
              )
            ]),
            _vm._m(3)
          ]),
          _c("div", { staticClass: "box b6" }, [
            _vm._m(4),
            _c("div", { staticClass: "chartBox" }, [
              _c(
                "div",
                [
                  _c("console-pie", {
                    attrs: { id: "chart1", chartData: _vm.chartSign }
                  })
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("console-pie", {
                    attrs: { id: "chart2", chartData: _vm.chartApproval }
                  })
                ],
                1
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "right-box" }, [
          _c("div", { staticClass: "box-1" }, [
            _vm._m(5),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "box-con" }, [
                _c("h1", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.userCount.successCount))
                ]),
                _vm._m(6)
              ]),
              _c("div", { staticClass: "box-con" }, [
                _c("h1", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.userCount.inviteCount))
                ]),
                _vm._m(7)
              ]),
              _c("div", { staticClass: "box-con" }, [
                _c("h1", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.userCount.removeCount))
                ]),
                _vm._m(8)
              ])
            ]),
            _c("div", { staticClass: "foot", on: { click: _vm.showAddMem } }, [
              _c("img", { attrs: { src: "/images/console/add.png" } }),
              _vm._v("添加成员\n        ")
            ])
          ]),
          _c("div", { staticClass: "box-2" }, [
            _vm._m(9),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                { staticClass: "can_use mod", on: { click: _vm.turnToZZ } },
                [
                  _c("i", { staticClass: "in-icon ic1" }),
                  _c("p", [_vm._v("企业组织管理")])
                ]
              ),
              _c(
                "div",
                { staticClass: "can_use mod", on: { click: _vm.turnToSP } },
                [
                  _c("i", { staticClass: "in-icon ic2" }),
                  _c("p", [_vm._v("成员合同审批")])
                ]
              ),
              _c(
                "div",
                { staticClass: "can_use mod", on: { click: _vm.turnToYZ } },
                [
                  _c("i", { staticClass: "in-icon ic3" }),
                  _c("p", [_vm._v("印章授权")])
                ]
              ),
              _c(
                "div",
                { staticClass: "can_use mod", on: { click: _vm.turnToMB } },
                [
                  _c("i", { staticClass: "in-icon ic4" }),
                  _c("p", [_vm._v("模板授权")])
                ]
              )
            ]),
            _c(
              "div",
              { staticClass: "foot can_use", on: { click: _vm.turnToJC } },
              [_vm._v("查看教程 >>")]
            )
          ])
        ])
      ]),
      _c("add-member", {
        attrs: { show: _vm.visibleAddMember, callback: _vm.addMemberSus },
        on: {
          "update:show": function($event) {
            _vm.visibleAddMember = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("img", { attrs: { src: "/images/console/zz_l.png" } }),
      _c("div", { staticClass: "i-tips-msk" }, [
        _c("p", { staticClass: "i-tips" }, [
          _vm._v(
            "\n              企业组织管理包括成员管理、权限管理、组织管理。您可调整架构、邀请成员、分配权限。\n            "
          )
        ])
      ]),
      _c("div", { staticClass: "des" }, [
        _c("p", { staticClass: "title" }, [_vm._v("成员管理")]),
        _c("p", { staticClass: "tips" }, [
          _vm._v(
            "\n              邀请成员加入，调整成员部门、分配成员权限、移出组织架构，数据转移继承\n            "
          )
        ]),
        _c("p", { staticClass: "title" }, [_vm._v("权限管理")]),
        _c("p", { staticClass: "tips" }, [
          _vm._v(
            "\n              设置角色权限按需授权，获得权限的成员则可以使用系统相应的功能\n            "
          )
        ]),
        _c("p", { staticClass: "title" }, [_vm._v("组织管理")]),
        _c("p", { staticClass: "tips" }, [
          _vm._v(
            "\n              树形结构管理体系，企业成员灵活管理，可与审批流程关联实现层级审批\n            "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("img", { attrs: { src: "/images/console/sp_l.png" } }),
      _c("div", { staticClass: "i-tips-msk" }, [
        _c("p", [
          _vm._v(
            "\n              合同审批流程包括文件审批、用印审批和流程审批。您可对文件审批、用印审批、流程审批进行设置。\n            "
          )
        ])
      ]),
      _c("div", { staticClass: "des" }, [
        _c("p", { staticClass: "title" }, [_vm._v("文件审批")]),
        _c("p", { staticClass: "tips" }, [
          _vm._v(
            "\n              若发出签署文件前需要先审阅文件的内容，则可以设置对应的“文件审批流程”，在发出签署文件时关联对应的“文件审批流程”，审批通过签署方才会收到对应的签署文件\n            "
          )
        ]),
        _c("p", { staticClass: "title" }, [_vm._v("用印审批")]),
        _c("p", { staticClass: "tips" }, [
          _vm._v(
            "\n              若签署文件时需要先审阅文件的内容，则需设置“用印审批流程”后与对应的印章做关联绑定，签署文件时审批通过，印章才会落到签署文件上\n            "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("img", { attrs: { src: "/images/console/yz_l.png" } }),
      _c("div", { staticClass: "i-tips-msk" }, [
        _c("p", [
          _vm._v(
            "\n              企业印章管理包括印章创建、印章授权和审批关联。您可进行添加印章、授权印章、关联印章和流程等操作。\n            "
          )
        ])
      ]),
      _c("div", { staticClass: "des" }, [
        _c("p", { staticClass: "title" }, [_vm._v("印章创建")]),
        _c("p", { staticClass: "tips" }, [
          _vm._v(
            "\n              把签署各种文件时需要用到的“印章”，以“透明印模图片”的形式上传到系统中集中管理\n            "
          )
        ]),
        _c("p", { staticClass: "title" }, [_vm._v("印章授权")]),
        _c("p", { staticClass: "tips" }, [
          _vm._v(
            "\n              按需把不同用途的印章，分别授权给相应的企业成员在签署不同文件时使用\n            "
          )
        ]),
        _c("p", { staticClass: "title" }, [_vm._v("审批关联")]),
        _c("p", { staticClass: "tips" }, [
          _vm._v(
            "\n              使用印章签署文件时若需要先审阅文件内容，则需要将印章与对应的“用印审批流程”进行关联，审批通过印章才会落到需签署文件上\n            "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("img", { attrs: { src: "/images/console/mb_l.png" } }),
      _c("div", { staticClass: "i-tips-msk" }, [
        _c("p", [
          _vm._v(
            "\n              企业模板管理包括模板维护、模板授权和批量发起。您可进行维护模板、新建模板、授权模板和批量发起模板等操作。\n            "
          )
        ])
      ]),
      _c("div", { staticClass: "des" }, [
        _c("p", { staticClass: "title" }, [_vm._v("模板维护")]),
        _c("p", { staticClass: "tips" }, [
          _vm._v(
            "\n              把各类业务签署时需要使用到的文档，创建为模板统一管理维护，避免文档模板使用中逐渐碎片化\n            "
          )
        ]),
        _c("p", { staticClass: "title" }, [_vm._v("模板授权")]),
        _c("p", { staticClass: "tips" }, [
          _vm._v(
            "\n              按需把不同类型的模板授权给相应的成员使用，防止成员私自使用不规范文档模板签署，避免不必要的司法纠纷\n            "
          )
        ]),
        _c("p", { staticClass: "title" }, [_vm._v("批量发起")]),
        _c("p", { staticClass: "tips" }, [
          _vm._v(
            "\n              使用时，支持通过Excel按不同的签署方分别录入不同的内容到模板中，并批量发出多份签署文件\n            "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("img", { attrs: { src: "/images/console/sjtj-i.png" } }),
      _c("span", { staticClass: "title" }, [_vm._v(" 数据统计")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("span", [_c("i"), _vm._v("企业成员")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "in-icon ic1" }),
      _vm._v("已加入")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "in-icon ic2" }),
      _vm._v("待接受")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "in-icon ic3" }),
      _vm._v("已移除")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("span", [_c("i"), _vm._v("快捷入口")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-377935ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-377935ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/consoleIndex.vue
// module id = UNVv
// module chunks = 11